import { combineReducers } from "redux";
import applicationReducer from "application/redux/applicationReducer";
import browseMediaReducer from "browse-media/redux/browseMediaReducer";
import authReducer from "auth/authReducer";
import manageModulesReducer from "manage-modules/redux/manageModulesReducer";
import editMediaReducer from "edit-media/redux/editMediaReducer";
import { mediaViewerReducer } from "media-viewer/mediaViewerRedux";
import { connectRouter } from "connected-react-router";

export default function (history) {
  return combineReducers({
    application: applicationReducer,
    auth: authReducer,
    browseMedia: browseMediaReducer,
    manageModules: manageModulesReducer,
    router: connectRouter(history),
    editMedia: editMediaReducer,
    mediaViewer: mediaViewerReducer,
  });
}
